export const shareLinkUrl = 'share-link/';
